import type { Params, RouteObject } from 'react-router';
import { paths } from '@/config/paths';
import type { RouteHandle } from '@/shared/routing';
import { HELP_TITLES } from './content/titles.generated';

// Titles come from the small title map so they are set before the help content has loaded.
const helpTitle = ({ section, topic }: Params) => {
  const title = HELP_TITLES[topic ? `${section ?? ''}/${topic}` : (section ?? '')];
  const home = HELP_TITLES[''] ?? 'Help';
  return section && title ? `${title} · ${home}` : home;
};

const metamodelTitle = ({ view, kind, key }: Params) => {
  const home = HELP_TITLES[''] ?? 'Help';
  const metamodel = HELP_TITLES.metamodel ?? 'Metamodel';
  const section = kind === 'kpi' ? 'kpis' : kind === 'screen' ? 'screens' : 'data-model';
  const node = view === 'lineage' && key ? HELP_TITLES[`${section}/${key}`] : undefined;
  const page =
    node ?? (view === 'data-model' ? 'Data model' : view === 'lineage' ? 'Lineage' : undefined);
  return [page, metamodel, home].filter(Boolean).join(' · ');
};

/** Help imported from OAA-BI-FE/Help: `/help`, `/help/:section`, `/help/:section/:topic`. */
export const createHelpRoutes = (): RouteObject[] => [
  {
    path: `${paths.help.metamodel()}/:view?/:kind?/:key?`,
    handle: { title: metamodelTitle } satisfies RouteHandle,
    lazy: { Component: async () => (await import('./pages/MetamodelPage')).MetamodelPage },
  },
  {
    path: `${paths.help.root}/:section?/:topic?`,
    handle: { title: helpTitle } satisfies RouteHandle,
    lazy: { Component: async () => (await import('./pages/HelpPage')).HelpPage },
  },
];
